import { Component, OnInit } from '@angular/core';

@Component({
    selector: 're-maintenance-info-banner',
    templateUrl: './maintenance-info-banner.component.html',
    styleUrls: ['./maintenance-info-banner.component.scss'],
    standalone: false
})
export class MaintenanceInfoBannerComponent implements OnInit {

  readonly displayMessageUntil = new Date("May 29, 2024 3:00 GMT-0500 am");
  ngOnInit(): void {

    this.show = this.displayMessage();
    //if the message is showing, setup a timer to hide it when the date has passed
    //once the message is hidden it wont be shown again so disable the timer
    if (this.show) {
      let interval = setInterval(() => {

        let show = this.displayMessage();
        if (!show) {
          this.show = false;
          clearInterval(interval);
        }

      }, 60000);
    }

  }

  private displayMessage() {
    let currentDate = new Date();
    return currentDate < this.displayMessageUntil;

  }
  public show = false;
}
